import product from '../../api/product';
import modal from '../../smartpak/modal';

export default function gridInterrupters($interrupters) {
    $interrupters.forEach($element => {
        const { ids, title, campaign } = $element.dataset;

        $element.addEventListener('click', event => {
            event.preventDefault();
            product.getProductClassDTOList(ids.split(',')).done(products => showModal(title, buildProductList(products, campaign)));
        });
    });
}

function applyCampaign(url, campaign) {
    if (!campaign) {
        return url;
    }

    return `${url}${url.includes('?') ? '&' : '?'}intcamp=${campaign}&from=interrupter`;
}

function buildProductList(products, campaign) {
    return `<ul class="shop-look-list">${products.map(({ Url, WebImage, Name, Price }) => {
        return `<li><a href="${applyCampaign(Url, campaign)}">
            <div class="shop-image"><img src="${WebImage}?w=145" width="145" height="145" /></div>
            <div class="shop-name">${Name}</div>
            <div class="shop-price">${Price}</div>
        </a></li>`;
    }).join('')}</ul>`;
}

function showModal(title, content) {
    const $content = document.createElement('div');
    $content.innerHTML = content;

    modal($content, {
        title,
        width: 430
    });
}

